// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest,getRequestGangAn } from '@/libs/axios';

// 分页获取消息信息
export const _getByPage = (params) => {
    return getRequest('/powerUser/getByPage', params)
};

//添加或修改权利人
export const _add = (params) => {
    return postRequest('/powerUser/add', params)
};

//获取作者、著作权人列表
export const _obligeeList = (params) => {
    return getRequest("/powerUser/getAllList", params )
}

//获取前海版权公共服务平台权利人详情
export const _obligeePowerUser = (params) => {
    return getRequest("/powerUser/get/" + params )
}
//删除前海版权公共服务平台权利人
export const _obligeePowerUserDelete = (params) => {
    return getRequest("/powerUser/delete/" + params )
}
//修改前海版权公共服务平台权利人
export const updatePowerUserIdentity = (params) => {
    return getRequest('/powerUser/updatePowerUserIdentity', params)
};